import { StatusPill } from '@vnetwork/ui/data';

interface ActiveStatusPillProps {
  /** API numeric status: 1 = active, anything else = inactive */
  value: number;
}

/** Thin port of ActiveStatusPill.tsx — maps numeric 1/0 to success/muted StatusPill. */
export function ActiveStatusPill({ value }: ActiveStatusPillProps) {
  const isActive = Number(value) === 1;
  return (
    <StatusPill tone={isActive ? 'success' : 'muted'}>
      {isActive ? 'Active' : 'Inactive'}
    </StatusPill>
  );
}
